import DynatraceMetricConfigurer, { queryFinder } from './metricConfigurer';

import { metricStoreConfigStore } from '@spinnaker/kayenta';


metricStoreConfigStore.register({
  name: 'dynatrace',
  metricConfigurer: DynatraceMetricConfigurer,
  queryFinder,
});
